// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__0AjDJ","loading":"Loader_loading__X8xsr"};